<div *ngIf="!showCompanySelection">
  <h2>Sign In</h2>
  <form autocomplete="off" *ngIf="currentState === stateMap.GET_OTP" [formGroup]="getOtpForm">
    <div class="form-group">
      <label class="login-label" for="user-email-address">Enter Registered Email Address</label>
      <input type="email" id="user-email-address" [attr.value]="getOtpForm.get('username').value"
        formControlName="username" class="form-control login-form-input-box login-input" name="user-email-address">
    </div>
    <button type="submit" (click)="submitEmailForOtp()" class="btn btn-thick btn-success btn-block">Get OTP</button>
    <div class="pt-4">
      <a class="font-small cp-hyperlink" routerLink='/terms'>Terms And Conditions</a>
    </div>
    <div class="pt-2">
      <a class="font-small cp-hyperlink" routerLink='/privacy-policy'>Privacy Policy</a>
    </div>
  </form>

  <form autocomplete="off" *ngIf="currentState === stateMap.LOGIN" [formGroup]="loginWithOtpForm">
    <div class="form-group">
      <label class="login-label" for="user-email-address">Registered Email Address</label>
      <div class="d-inline">
        <input type="email" id="user-email-address" [attr.value]="loginWithOtpForm.get('username').value"
          [disabled]="true" formControlName="username" class="d-inline form-control login-form-input-box login-input"
          name="user-email-address" [attr.disabled]="true">
        <span class="edit-password" id="edit-username" (click)="editUsername()" (keydown.enter)="editUsername()" (keydown.space)="editUsername()">
          <img src='/assets/images/edit.svg' class="cp-button-icon" alt="edit">
        </span>
      </div>
      <div class="error-text"
        *ngIf="(!loginWithOtpForm.controls['username'].pristine) && loginWithOtpForm.controls['username'].errors">
        <small class="medium-font" [hidden]="!loginWithOtpForm.controls['username'].errors.email">
          Please enter a valid email address.
        </small>
        <small class="medium-font" [hidden]="!loginWithOtpForm.controls['username'].errors.required">
          Your registered email address is required.
        </small>
      </div>
    </div>
    <div class="form-group">
      <label class="login-label" for="login-otp">Enter OTP</label>
      <input type="number" id="login-otp" [attr.value]="loginWithOtpForm.get('otp').value" formControlName="otp"
        class="form-control login-form-input-box login-input" name="login-otp">
      <div class="error-text"
        *ngIf="(!loginWithOtpForm.controls['otp'].pristine) && loginWithOtpForm.controls['otp'].errors">
        <small class="medium-font" [hidden]="!loginWithOtpForm.controls['otp'].errors.required">
          OTP (sent to your registered Mobile Number) is required.
        </small>
      </div>
    </div>
    <div class="login-page-link">
      <span class="resend-text" id="otp-counter" *ngIf="otpCounterSecondsRemaining > 0">Resend OTP in
        {{otpCounterSecondsRemaining * 1000 | millisecondsFormatter}}</span>
      <span *ngIf="otpCounterSecondsRemaining === 0" class="resend-text">Didn't Receive OTP Yet? &nbsp;&nbsp;</span>
      <a id="resend-otp" *ngIf="otpCounterSecondsRemaining === 0" (click)="resendOtp()">Resend OTP.</a>
    </div>

    <div class="form-group">
      <label class="login-label" for="password">Password</label>
        <input
        id="password"
        type="text"
        formControlName="password"
        class="form-control masked-input"
        name="userSecretCode"
        autocomplete="off"
        autocorrect="off"
        spellcheck="false"
        (input)="maskPassword($event)"
        #passwordInput
      />
      <div class="error-text"
        *ngIf="(!loginWithOtpForm.controls['password'].pristine) && loginWithOtpForm.controls['password'].errors">
        <small class="medium-font" [hidden]="!loginWithOtpForm.controls['password'].errors.required">
          Login Password is required.
        </small>
      </div>
      <span>
        <a id="forgot-password-link" routerLink='/login/forgot-password'>Forgot your password?</a>
      </span>
    </div>

    <button type="submit" (click)="loginWithOtp()" class="btn btn-thick btn-success btn-block" id="login-button"
      [attr.disabled]="!loginWithOtpForm.valid  ? true : null">Login</button>
    <div class="pt-4">
      <a class="font-small cp-hyperlink" routerLink='/terms'>Terms And Conditions</a>
    </div>
    <div class="pt-2">
      <a class="font-small cp-hyperlink" routerLink='/privacy-policy'>Privacy Policy</a>
    </div>
  </form>
</div>

<app-company-selection *ngIf="showCompanySelection" [companiesList]="companiesList"
  (errorEvent)="handleLoginErrorResponse($event)" (companySelectionEvent)="handleProcessesPostLogin($event)">
</app-company-selection>
